import React from 'react'
import Home from '../Components/Our-Project/Home/Home'
import Project from '../Components/Our-Project/Project/Project'

const ProjectPage = () => {
  return (
    <>
        <Home />
        <Project />
    </>
  )
}

export default ProjectPage